const AppConfig = {
    baseUrl() {
        return process.env.REACT_APP_API_ENDPOINT;
    },
    uiUrl() {
        return process.env.REACT_APP_UI_ENDPOINT;
    },
    version: 1
}

export default AppConfig;